import {
  CurrencyDisplay,
  FormContainer,
  SearchBar,
  SwitchAppContentSwitcher,
  ThreeDotsLoaderAnimatedSvg,
} from "../../components";

import switchAppIcon from "../../assets/images/switchapp-logo.svg";
import { TransactionIFrame } from "./TransactionIFrame";
import {
  IHostedPaymentLinkViewProps,
  TPaymentMethodName,
} from "./HostedPaymentLinks";
import { GatewayForm } from "./GatewayForm";
import { DirectCardChargeForm } from "./DirectCardChargeForm";
import { OrderCompletedPage } from "./OrderCompletedPage";
import { PaymentFailedPage } from "./PaymentFailedPage";
import { SaleTotal } from "./SaleTotal";
import { truncateStringWithEllipsis } from "../../utils";
import { transactionType } from "../../enums";

export const View = ({
  isPreviewMode,

  isCancelButtonHidden,

  searchLineItemsText,
  setSearchLineItemsText,

  isSuccessHostedPaymentLink,
  isOrderCompletePageVisible,
  isPaymentFailedPageVisible,
  hostedPaymentLink,
  paymentMethodName,
  tx_ref,
  iframeUrl,
  isIframeOpen,
  paymentMethodSwitcherVisible,
  sendCheckoutClosedEvent,
  setPaymentMethodName,
  showSuccessPage,
  openInIframe,
  closeIframe,
  closeIframeShowSuccessMessage,
  closeIframeShowFailedMessage,
}: IHostedPaymentLinkViewProps) => {
  const showAuthInputs =
    isIframeOpen || isOrderCompletePageVisible || isPaymentFailedPageVisible;

  const tempPaymentLinkHiddenClassName = hostedPaymentLink?.is_temp_payment_link
    ? "d-none"
    : "";

  const SocialMediaLink = ({
    link_url,
    imageUrl,
    socialMediaName,
    text = "view more about this item and other available products",
  }: {
    link_url: string;
    imageUrl: string;
    socialMediaName: string;
    text?: string;
  }) => (
    <div className="social-icon--link">
      <a href={link_url} target="_blank" rel="noreferrer">
        <div className="flex-container align-items--end">
          <img
            src={imageUrl}
            className="social-icon"
            alt={`${socialMediaName} icon`}
          />
          <span className="switchapp-small">{text}</span>
        </div>
      </a>
    </div>
  );

  return !hostedPaymentLink ? (
    <div className="flex-container h-100 col justify-content--center align-items--center">
      {/* <DataLoadingView message="Loading payment link..." /> */}
      <ThreeDotsLoaderAnimatedSvg fill="rgb(89, 145, 255)" />
    </div>
  ) : (
    <>
      <div
        className={`inline-payment--container flex-container col align-items--center ${
          paymentMethodName === "gateway" ? "is-gateway-selection" : ""
        }`}
      >
        <FormContainer>
          {isCancelButtonHidden ? null : (
            <span
              className="cancel-payment"
              title="cancel payment"
              onClick={async () => {
                if (
                  window.confirm("Are you sure you want to close the page?")
                ) {
                  // call switchapp api to to save event
                  // await sendCheckoutClosedEvent(hostedPaymentLink.tx_ref);

                  // close window for permanent payment links; ERROR:scripts may only close windows opened by them
                  // if (!hostedPaymentLink.is_temp_payment_link) window.close();

                  (window as any).parent.postMessage(
                    {
                      switchappId: "switchapp-inline-message",
                      action: "callFunction",
                      targetFunction: "onClose",
                      params: {
                        event: "checkout.closed",
                        reference: hostedPaymentLink.tx_ref,
                      },
                    },
                    "*"
                    // hostNameFromRootBody
                    // window.location.href
                    // window.parent.location.href
                  );
                }
              }}
            >
              &times;
            </span>
          )}

          <div className="flex-container col justify-content--between align-items--start bb mb-5">
            <div className="flex-box flex-container align-items--start">
              <div className="merchant-logo--container">
                <img
                  src={
                    hostedPaymentLink.logo_url ||
                    hostedPaymentLink.merchant_logo_url ||
                    switchAppIcon
                  }
                  alt="merchant logo"
                  className="merchant-logo"
                />
              </div>

              <div className="flex-box flex-container col justify-content--between align-items--start ml-5">
                {hostedPaymentLink.is_top_up_payment_link ? (
                  <h6 className="form-section--title font-ctm--bold ml-5 mr-5 align-self--end">
                    Top up your wallet
                  </h6>
                ) : (
                  <>
                    <h6 className="form-section--title font-ctm--bold">
                      {hostedPaymentLink.title || "Make payment to"}
                    </h6>
                    <h5 title={hostedPaymentLink.merchant_name || ""}>
                      {truncateStringWithEllipsis(
                        hostedPaymentLink.description ||
                          hostedPaymentLink.merchant_name,
                        200
                      )}
                    </h5>
                  </>
                )}
              </div>
            </div>

            <h3
              id="sale-total-portal"
              className="font-ctm--bold flex-container align-self--end sale-total"
            >
              {/* Used to render the sale total as customer changes qty */}
              {hostedPaymentLink.is_temp_payment_link ? (
                <CurrencyDisplay
                  useSymbolAsIs
                  currencyOrSymbol={hostedPaymentLink.currency}
                  amount={
                    hostedPaymentLink.temp_payment_link_amount +
                    hostedPaymentLink.temp_payment_link_app_fee
                  }
                />
              ) : (
                <SaleTotal />
              )}
            </h3>
          </div>

          <div className="flex-container flex-break--small">
            <div
              className={`paymentlink-lineitems--container flex-box flex-container col ${tempPaymentLinkHiddenClassName}`}
            >
              {/* <div className="flex-container flex-break--small justify-content--between mb-5">
                <span className="form-section--title">
                  Pay {hostedPaymentLink.merchant_name}
                </span>
              </div> */}

              {isCancelButtonHidden ||
              hostedPaymentLink.line_items.length <= 5 ? null : (
                <SearchBar
                  name="search-list-items"
                  // value={searchLineItemsText}
                  placeholder="Search products..."
                  onChange={(e: any) => setSearchLineItemsText(e.target.value)}
                  onClear={() => setSearchLineItemsText("")}
                />
              )}

              {/* Render the products & merchant details here */}
              <div className="sale-items-portal--container flex-box">
                <div id="sale-items-portal" className="flex-container col">
                  {/* Used to render the sale line items */}
                </div>
              </div>

              <div className="social-icons--container justify-content--start align-items--start align-self--stretch">
                {!hostedPaymentLink.enable_social_media_links ? null : (
                  <>
                    {hostedPaymentLink.instagram_url ? (
                      <SocialMediaLink
                        link_url={hostedPaymentLink.instagram_url}
                        imageUrl={`/social-icons/instagram.png`}
                        socialMediaName={"instagram"}
                      />
                    ) : null}

                    {hostedPaymentLink.facebook_url ? (
                      <SocialMediaLink
                        link_url={hostedPaymentLink.facebook_url}
                        imageUrl={`/social-icons/facebook.png`}
                        socialMediaName={"facebook"}
                      />
                    ) : null}

                    {hostedPaymentLink.whatsapp_url ? (
                      <SocialMediaLink
                        link_url={hostedPaymentLink.whatsapp_url}
                        imageUrl={`/social-icons/whatsapp.png`}
                        socialMediaName={"WhatsApp"}
                      />
                    ) : null}
                  </>
                )}
              </div>
            </div>

            <div
              className={`flex-divider--vertical ${tempPaymentLinkHiddenClassName}`}
            />

            <div className="flex-container col align-items--stretch">
              {isIframeOpen ? (
                <TransactionIFrame
                  tx_ref={tx_ref}
                  tx_type={
                    hostedPaymentLink.is_top_up_payment_link
                      ? transactionType.topUp
                      : transactionType.payment
                  }
                  iframeUrl={iframeUrl}
                  closeIframe={closeIframe}
                  closeIframeShowSuccessMessage={closeIframeShowSuccessMessage}
                  closeIframeShowFailedMessage={closeIframeShowFailedMessage}
                  // closeIframeShowPendingMessage={closeIframeShowPendingMessage}
                />
              ) : isOrderCompletePageVisible ? (
                <OrderCompletedPage
                  // merchant_name={}
                  currency={hostedPaymentLink.currency}
                  amount={hostedPaymentLink.amount}
                  title={
                    hostedPaymentLink.is_top_up_payment_link
                      ? "Top-up successful"
                      : "Thanks for your payment"
                  }
                  successMessage={`Your ${
                    hostedPaymentLink.is_top_up_payment_link
                      ? "top-up"
                      : "transaction"
                  } has been completed successfully`}
                />
              ) : isPaymentFailedPageVisible ? (
                <PaymentFailedPage
                  // merchant_name={}
                  currency={hostedPaymentLink.currency}
                  amount={hostedPaymentLink.amount}
                />
              ) : null}

              <div className={`${!showAuthInputs ? "d-block" : "d-none"}`}>
                <div className="flex-container col align-items--center mt-5">
                  {!hostedPaymentLink.show_payment_providers ||
                  !paymentMethodSwitcherVisible ? null : (
                    <SwitchAppContentSwitcher<TPaymentMethodName>
                      onChange={({ name }) => {
                        setPaymentMethodName(name);
                      }}
                      options={[
                        {
                          key: "Payment options",
                          value: "gateway",
                        },
                        {
                          key: "Card",
                          value: "card",
                        },
                      ]}
                      selectedValue={paymentMethodName}
                    />
                  )}
                </div>

                {/* 
                    NOTE: card/gateway are unmounted b/c SaleTotal and shared input-field values eg email
                    etc are not refreshed synchronized unless a full re-render occurs
                */}
                {paymentMethodName === "card" ? (
                  <div
                    className={`${
                      paymentMethodName === "card" ? "d-block" : "d-none"
                    }`}
                  >
                    <DirectCardChargeForm
                      isPreviewMode={isPreviewMode}
                      tx_ref={tx_ref}
                      isActive={paymentMethodName === "card"}
                      isLineItemQtyInputTempDisabled={
                        paymentMethodName !== "card" ||
                        isIframeOpen ||
                        isOrderCompletePageVisible
                      }
                      isSuccessHostedPaymentLink={isSuccessHostedPaymentLink}
                      hostedPaymentLink={hostedPaymentLink}
                      openInIframe={openInIframe}
                      showSuccessPage={showSuccessPage}
                    />
                  </div>
                ) : null}

                {paymentMethodName === "gateway" ? (
                  <div
                    className={`${
                      paymentMethodName === "gateway" ? "d-block" : "d-none"
                    }`}
                  >
                    <GatewayForm
                      isPreviewMode={isPreviewMode}
                      isActive={paymentMethodName === "gateway"}
                      isLineItemQtyInputTempDisabled={
                        paymentMethodName !== "gateway" ||
                        isIframeOpen ||
                        isOrderCompletePageVisible
                      }
                      isSuccessHostedPaymentLink={isSuccessHostedPaymentLink}
                      hostedPaymentLink={hostedPaymentLink}
                      showSuccessPage={showSuccessPage}
                      openInIframe={openInIframe}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="company-name--footer flex-container align-items--center">
            <div className="company-name mr-5">
              <span className="powered-by">Powered By</span>{" "}
              <img
                src={switchAppIcon}
                alt="payment methods"
                className="footer-logo"
              />
            </div>
          </div>
        </FormContainer>
      </div>
    </>
  );
};
